import type { OnboardingStepId, UserRole } from '@inou/shared';

import { type NavTarget, toMcpSettings, toMembers, toProjects, toTenantSettings } from '@/lib/nav';

/**
 * 案内する 5 つと、その理由・飛び先。
 *
 * 並びと ID の正は API (`@inou/shared` の `ONBOARDING_STEP_IDS`)。
 * ここは ID ごとの見せ方だけを持ち、並べ替えもしない。
 *
 * `minRole` は**その操作を実行できる最低ロール**で、飛び先の画面を開ける
 * ロール (経路の表が持つ) とは別物。`/settings/tenant` は member でも開けるが
 * 単価を保存できるのは admin なので、member には出さない
 * (押しても何もできないリンクを見せない)。
 */
export interface OnboardingStepView {
  id: OnboardingStepId;
  title: string;
  /** なぜ要るかを 1 行で。手順は書かない (設定画面とヘルプが持つ) */
  reason: string;
  minRole: UserRole;
  target: NavTarget;
  /** リンクの表示名 */
  action: string;
}

export const ONBOARDING_STEPS: readonly OnboardingStepView[] = [
  {
    id: 'rates',
    title: '売上と原価の既定単価を入れる',
    reason: '0 のままだと収支レポートの金額が全部 0 円になります。',
    minRole: 'admin',
    target: toTenantSettings(),
    action: 'テナント設定',
  },
  {
    id: 'project',
    title: 'プロジェクトを 1 つ作る',
    reason: '工数の記録先です。1 つも無いと AI クライアントから記録できません。',
    minRole: 'admin',
    target: toProjects(''),
    action: 'プロジェクト',
  },
  {
    id: 'repository',
    title: 'リポジトリを紐付ける',
    reason:
      '作業中のリポジトリからプロジェクトが決まるので、AI に「どの案件ですか」と聞かれなくなります。',
    minRole: 'admin',
    target: toProjects(''),
    action: 'プロジェクト',
  },
  {
    id: 'token',
    title: 'トークンを発行して AI クライアントをつなぐ',
    reason: 'ここまで来ると、普段どおり会話するだけで工数が記録されます。',
    minRole: 'mcp',
    target: toMcpSettings(),
    action: 'MCP接続',
  },
  {
    id: 'member',
    title: 'メンバーを招待する',
    reason: '一人でも始められます。人が増えたときで構いません。',
    minRole: 'admin',
    target: toMembers(),
    action: 'メンバー',
  },
];
